import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';

export const TransportAssignmentBulkSelectionCodec = t.type({
    assignment_ids: t.array(NonEmptyString),
});

export type ApiTransportAssignmentBulkSelection = t.TypeOf<typeof TransportAssignmentBulkSelectionCodec>;
